import React, {Fragment} from 'react';

export default function ConversionComponentSummary({ summary }) {
    return (
        <>
            {Object.entries(summary?.categories || {})?.map(([key, category]) => (
                <div key={key} className="col-12">
                        {category?.title && (
                            <p className="summary-category-title font-weight-bold text-lg">
                                {category?.title}
                            </p>
                        )}
                        <div className="row row--bordered gutters-1" key={key}>

                            {Object.entries(category?.values || {})?.map(([key, value], index) => (
                                <Fragment key={index}>
                                    <div className="col-12">
                                        <div className="row gutters-2">
                                            <div className="col-6">
                                                <p className="text-sm">{value?.label}</p>
                                            </div>
                                            <div className="col-6">
                                                <p className="text-sm">{value?.value}</p>
                                            </div>
                                        </div>
                                    </div>
                                </Fragment>
                            ))}
                        </div>

                </div>
            ))}
        </>
    )
}
